module.exports = __webpack_public_path__ + "static/media/10d.55666873.svg";